<template>
    <div id="checkout-staff-popup" v-if="popupStaff.item_info">
        <vs-popup class="checkout-staff-popup" :title="`Choose Staff For ${popupStaff.item_info.service ? popupStaff.item_info.service.name : 'this service'}`" :active.sync="popupStaff.isOpen">
            <div class="flex p-6 w-full" style="position: absolute; top: 0; left: 0">
                <div class="con-input-search vs-table--search m-0 w-full" style="max-width: unset">
                    <input type="text" class="input-search vs-table--search-input rounded-item border-custom py-3 text-sm w-full" @input="searchStaff" placeholder="Search staff...">
                    <i class="vs-icon notranslate icon-scale material-icons null">search</i>
                </div>

                <div class="pl-4 flex">
                    <feather-icon
                        icon="GridIcon"
                        @click="currentItemView='staff-grid'"
                        class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                        :svgClasses="{'text-primary stroke-current': currentItemView == 'staff-grid'}"
                    />
                    <feather-icon
                        icon="ListIcon"
                        @click="currentItemView='staff-list'"
                        class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer hidden sm:inline-flex"
                        :svgClasses="{'text-primary stroke-current': currentItemView == 'staff-list'}"
                    />
                </div>
            </div>
            <div v-if="showService" class="pl-2" style="margin-top: 70px;">
                <p class="mb-4 font-bold text-lg">Select staff for <span v-if="serviceList.length > 1">these services</span> <span v-else>this service</span>: </p>
                <div style="height: 57px; overflow: hidden">
                    <div class="pt-2 h-full overflow-auto">
                        <span class="flex flex-wrap">
                            <vs-checkbox v-for="(service, index) in serviceList" :key="index" v-model="service.selected" class="mr-6 mb-3">{{service.item_name}}</vs-checkbox>
                        </span>
                    </div>
                </div>
            </div>

            <div v-if="type=='checkout' && staffListWithSearch.length > 0" style="overflow-y: auto;" class="checkout-staff-popup-scroll"
                :style="`max-height: calc(100vh - ${showService ? 325 : 205}px); margin-top: ${showService ? 30 : 70}px;`">
                <vs-row vs-w="12" v-if="currentItemView == 'staff-grid'">
                    <vs-col class="popup-staff-col" v-for="(staff, index) in staffListWithSearch" :key="index" @click.native="selectStaff(staff)">
                        <my-staff-item type="grid" class="m-2" :staffData="staff" :isSelected="staffInService(staff)" :key="index + '' + abc"></my-staff-item>
                    </vs-col>
                </vs-row>

                <vs-row vs-w="12" v-if="currentItemView == 'staff-list'" class="border-bottom-custom">
                    <vs-col vs-w="12" v-for="(staff, index) in staffListWithSearch" :key="index" @click.native="selectStaff(staff)">
                        <my-staff-item type="list" :staffData="staff" :isSelected="staffInService(staff)" :key="index + '' + abc"></my-staff-item>
                    </vs-col>
                </vs-row>
            </div>

            <div v-else-if="type=='appointment' && staffListWithSearchAppt.length > 0" class="checkout-staff-popup-scroll" style="max-height: calc(100vh - 205px); overflow-y: auto; margin-top: 70px">
                <vs-row vs-w="12" v-if="currentItemView == 'staff-grid'">
                    <vs-col class="popup-staff-col" v-for="(staff, index) in staffListWithSearchAppt" :key="index" @click.native="selectStaff(staff)">
                        <my-staff-item type="grid" class="m-2" :staffData="staff" :isSelected="staffInService(staff)" :key="index + '' + abc"></my-staff-item>
                    </vs-col>
                </vs-row>

                <vs-row vs-w="12" v-if="currentItemView == 'staff-list'" class="border-bottom-custom">
                    <vs-col vs-w="12" v-for="(staff, index) in staffListWithSearchAppt" :key="index" @click.native="selectStaff(staff)">
                        <my-staff-item type="list" :staffData="staff" :isSelected="staffInService(staff)" :key="index + '' + abc"></my-staff-item>
                    </vs-col>
                </vs-row>
            </div>
            <div v-else class="flex justify-center" style="margin-top: 85px">No data available</div>
        </vs-popup>
    </div>
</template>

<script>
export default {
    name: 'checkout-staff-popup',
    props: {
        popupStaff: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            default: 'checkout'
        }
    },
    data() {
        return {
            search: '',
            abc: 0,
            currentItemView: 'staff-grid',
            showService: false,
            serviceList: []
        }
    },
    watch: {
        popupStaff: {
            immediate: true,
            deep: true,
            handler() {
                if(this.popupStaff.isOpen) {
                    this.currentItemView = 'staff-grid';
                }
                if(this.popupStaff && this.popupStaff.itemList && this.popupStaff.itemList.length > 0) {
                    this.showService = true;
                    this.serviceList = [];
                    for(let i = 0; i < this.popupStaff.itemList.length; i++) {
                        let item = JSON.parse(JSON.stringify(this.popupStaff.itemList[i]));
                        item.selected = true;
                        this.serviceList.push(item);
                    }
                }
            }
        }
    },
    computed: {
        // staffList() {
        //     return this.$store.getters['staffList/staffList'];
        // },
        staffListWithSearch() {
            return this.$store.getters['staffList/staffListWithSearch'](this.search);
        },
        staffListWithSearchAppt() {
            return this.$store.getters['staff/staffListWithSearch'](this.search);
        }
    },
    methods: {
        searchStaff({target}) {
            this.search = target.value; 
        },
        staffInService(staff) {
            if(this.popupStaff.item_info && this.popupStaff.item_info.staff && this.popupStaff.item_info.staff.user_id == staff.user_id) {
                return true;
            }
            return false;
        },
        selectStaff(staff) {
            if(this.showService) {
                let selected_items = '';
                for(let i = 0; i < this.serviceList.length; i++) {
                    if(this.serviceList[i].selected) {
                        if(selected_items == '') {
                            selected_items += this.serviceList[i].id;
                        } else {
                            selected_items += (',' + this.serviceList[i].id);
                        }
                    }
                }
                this.$emit('SelectStaff', { staff: staff, items: selected_items });
            } else {
                this.$emit('SelectStaff', staff);
            }
            this.abc++;
        }
    },
    created() {
        this.$store.dispatch("staffList/GET_STAFF_LIST", {page: 1, 'per-page': 100});
    }
}
</script>

<style lang="scss">
.con-vs-popup {
    &.checkout-staff-popup {
        z-index: 90000 !important;
        .vs-popup {
            width: calc(100% - 80px);
            height: auto;
            .vs-popup--content {
                width: auto;
                // height: calc(100vh - 200px);
                height: 100vh;
                // padding: 0;
                position: relative;

                // max-height: calc(100vh - 200px);
                // min-height: calc(100vh - 600px);
                margin: 0 !important;
                .popup-staff-col {
                    width: calc(100% / 3) !important;
                }
                @media (max-width: 900px) {
                    .popup-staff-col {
                        width: 50% !important;
                    }
                }

                @media (max-width: 600px) {
                    .popup-staff-col {
                        width: 100% !important;
                    }
                }
            }
        }
    }
}
</style>